import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import { fa } from 'vuetify/iconsets/fa-svg'

export default createVuetify({
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          primary: '#8A92B2',
          secondary: '#EFEFE8',
          tertiary: '#2F3854',
          accent: '#907954',
          error: '#D32F2F',
          success: '#4CAF50',
          background: '#161c30',
          card: '#192037',
          bar: '#0D171A',
          premium: '#365ABD',
          vip: '#907954',
        },
      },
    },
  },
  icons: {
    defaultSet: 'fa',
    sets: {
      fa,
    },
  },
})
